import { render } from "./Trades.vue?vue&type=template&id=29078dfd&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=js"
export * from "./Trades.vue?vue&type=script&lang=js"

import "./Trades.vue?vue&type=style&index=0&id=29078dfd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29078dfd"]])

export default __exports__